export default __webpack_public_path__ + "static/panbox-right-3689b1d269c6a817e2843b1f14e93e81.png";